import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Melbourne, Australia",
    image: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=150",
    rating: 5,
    text: "CloudJet made our Bali honeymoon absolutely perfect! From the moment we reached out, their team handled every detail with care. The resort they recommended was stunning, and all the surprise touches made it unforgettable.",
    trip: "Bali Honeymoon"
  },
  {
    id: 2,
    name: "James & Emma Thompson",
    location: "Sydney, Australia",
    image: "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=150",
    rating: 5,
    text: "As a family of five, planning holidays can be stressful. CloudJet took that stress away completely. Our Fiji trip was seamless - kid-friendly activities, beautiful accommodation, and memories we'll cherish forever.",
    trip: "Fiji Family Holiday"
  },
  {
    id: 3,
    name: "Michael Chen",
    location: "Brisbane, Australia",
    image: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150",
    rating: 5,
    text: "I've used CloudJet for three corporate retreats now. Their attention to detail and understanding of business travel needs is unmatched. Professional, responsive, and always delivers beyond expectations.",
    trip: "Corporate Retreat - Queenstown"
  },
  {
    id: 4,
    name: "Lisa Anderson",
    location: "Perth, Australia",
    image: "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=150",
    rating: 5,
    text: "The custom itinerary CloudJet created for my solo trip through Greece was incredible. They found hidden gems I never would have discovered on my own. Already planning my next adventure with them!",
    trip: "Greece Solo Adventure"
  },
  {
    id: 5,
    name: "David & Rachel Williams",
    location: "Adelaide, Australia",
    image: "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=150",
    rating: 5,
    text: "We celebrated our 25th anniversary in the Maldives thanks to CloudJet. The overwater villa, private dinners, and spa experiences were beyond our dreams. Worth every penny!",
    trip: "Maldives Anniversary"
  },
  {
    id: 6,
    name: "Sophie Taylor",
    location: "Gold Coast, Australia",
    image: "https://images.pexels.com/photos/1065084/pexels-photo-1065084.jpeg?auto=compress&cs=tinysrgb&w=150",
    rating: 5,
    text: "Best travel agency I've ever worked with! Quick responses, great prices, and genuine care for making your trip special. CloudJet turned my Santorini dreams into reality.",
    trip: "Santorini Getaway"
  }
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Testimonials
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-sky-900 mb-4">
            What Our Travelers Say
          </h2>
          <p className="text-sky-600 max-w-2xl mx-auto text-lg">
            Don't just take our word for it. Here's what our happy customers have to say about their CloudJet experience.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-sky-50 rounded-2xl p-6 border border-sky-100 hover-lift"
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <Quote className="text-sky-300" size={32} />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="fill-yellow-400 text-yellow-400" size={18} />
                ))}
              </div>

              {/* Text */}
              <p className="text-sky-700 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Trip Tag */}
              <div className="mb-4">
                <span className="inline-block bg-sky-200 text-sky-700 px-3 py-1 rounded-full text-sm font-medium">
                  {testimonial.trip}
                </span>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-sky-200">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-sky-900">{testimonial.name}</p>
                  <p className="text-sky-600 text-sm">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="mt-16 bg-sky-600 rounded-2xl p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center text-white">
            <div>
              <p className="text-4xl font-bold mb-2">4.9</p>
              <p className="text-sky-200">Average Rating</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">2,500+</p>
              <p className="text-sky-200">Happy Travelers</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">98%</p>
              <p className="text-sky-200">Would Recommend</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">15+</p>
              <p className="text-sky-200">Years Experience</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
